<template>
  <BadgeUi
    class="product-card-price-diff"
    :class="type ? 'product-card-price-diff--' + type : ''"
    type="primary"
  >
    <span class="product-card-price-diff__value">-{{ data.name }}</span>
  </BadgeUi>
</template>

<script>
import CurrencyFormatter from '@/filters/CurrencyFormatter'
import BadgeUi from '@/components/ui/BadgeUi'

export default {
  name: 'ProductCardPriceDiff',
  components: {
    BadgeUi
  },
  props: {
    price: {
      type: Number,
      default: null
    },
    oldPrice: {
      type: Number,
      default: null
    },
    showPercent: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: null
    }
  },
  filters: {
    CurrencyFormatter
  }
}
</script>

<style lang="sass" scoped>
.product-card-price-diff
  gap: 4px

.product-card-price-diff--adaptive-main-page,
.product-card-price-diff--simple-card
  font-size: 10px
</style>
